import axios from 'axios';
import getAppConfig from '../../config';
import { setGlobalLoader } from '../ui/uiActions';
import { setSnackBarAlert, caughtError } from '../ui/uiActions';
import { getQueryString } from '../../components/common/functions';

import {
  TEAM_GROUP_SET_INITIAL_STATE,
  TEAM_GROUP_FIND_ALL,
  TEAM_GROUP_VIEW
} from './teamGroupTypes';

const config = getAppConfig();

export const viewTeamGroup = (groupId) => {
  let URL = `${config.api.URL}/team-group/${groupId}`;
  return (dispatch) => {
    dispatch(onSuccessViewTeamGroup({data: false}))
    axios.get(URL).then(response => {
      dispatch(onSuccessViewTeamGroup(response))
    }).catch(error => {
      dispatch(caughtError(error))
    })
  }
}

export const deleteTeamGroup = (groupId, filterInput) => {
  let URL = `${config.api.URL}/team-group/mark-delete/${groupId}`;
  if(filterInput.deleted === true) {
    // if record already deleted
    URL = `${config.api.URL}/team-group/unmark-delete/${groupId}`;
  }
  return (dispatch) => {
    axios.patch(URL).then(response => {

      dispatch(setSnackBarAlert({
        openSnackBar: true,
        severity: 'success',
        message: `Success! teamGroup ${filterInput.deleted ? 'restored' : ' moved to trash'}`
      }))

      dispatch(findAllTeamGroups(filterInput));
    }).catch(error => {
      dispatch(caughtError(error))
    })
  }
}

export const findAllTeamGroups  = (filters="") => {
  let URL = `${config.api.URL}/team-group`;
  if(filters !== '') {
    URL = `${URL}?${getQueryString(filters)}`;
  }
  return (dispatch) => {
    dispatch(setGlobalLoader(true))
    axios.get(URL).then(response => {
      dispatch(setGlobalLoader(false))
      dispatch(onSuccessFindAllTeamGroup(response))
    }).catch(error => {
      dispatch(setGlobalLoader(false))
      dispatch(setTeamGroupInitialState())
      dispatch(caughtError(error))
    })
  }
}
export const setTeamGroupInitialState = () => {
  return {
    type: TEAM_GROUP_SET_INITIAL_STATE
  }
}

export const onSuccessViewTeamGroup = response => {
  return {
    type: TEAM_GROUP_VIEW,
    payload: response.data
  }
}

export const onSuccessFindAllTeamGroup = response => {
  return {
    type: TEAM_GROUP_FIND_ALL,
    payload: response.data
  }
}
